<script setup lang="ts">
// 로그인 레이아웃 설정
</script>

<template>
  <v-app class="login-app">
    <AppBar />
    <ClientDrawerRight />
    <v-main class="d-flex align-center justify-center" style="min-height: 100vh; background: #ffffff; padding-top: 100px;">
      <v-container fluid class="d-flex align-center justify-center" style="min-height: calc(100vh - 100px); padding-top: 20px; padding-bottom: 40px;">
        <v-row justify="center" no-gutters>
          <v-col cols="12" sm="10" md="8" lg="6" xl="4">
            <slot />
          </v-col>
        </v-row>
      </v-container>
    </v-main>

    <!-- 전역 다이얼로그 -->
    <GlobalDialog />
  </v-app>
</template>

<style scoped>
/* Vuetify 기본 스타일 보완 */
.login-app :deep(.v-main) {
  background: #ffffff;
  padding-top: 90px !important;
}
</style>
